import { Injectable } from '@angular/core';
import { BaseServiceInterface } from './base.service.interface';

@Injectable()
export class BaseService implements BaseServiceInterface {

}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts